/* eslint-disable prefer-const */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  memo,
  useMemo,
  useContext,
  forwardRef,
  useImperativeHandle,
  useLayoutEffect
} from "react";

import plusImg from "../../../../assets/images/homepage/ySafe/tableIcons/Plus.svg";
// import nodata from "assets/images/homepage/setting/No data.svg";

import Button from "components/Button/index";
import useTheme from "hooks/observer";
import SortIcons from "../../../../constants/Homepage/ysafe/iconFunctions/sortIcons";
import "./fileWrapper.scss";
import Dropdown from "components/DropDowns/customDropDown/index";
// import Table from "../table/index";
import useScreenMobile from "hooks/useScreen";
import GetActionIcon from "constants/Homepage/ysafe/iconFunctions/getActionIcon";
import Input from "components/Input/index";
import TextDropDown from "components/DropDowns/TextDropDowns/index";
import Drawer from "components/Drawer/index";
import { normalizeName } from "utils/normalizeName";
import Modal from "components/Models/index";
import UploadFileContent from "../UploadFileContent";
import { signInContext } from "context/SigninContext";
import UploadDropDown from "components/UploadDropDown/index";
import DeleteModal from "components/DeleteModal/index";
import ShareFiles from "../shareFiles/index";
import MoveFile from "components/MoveFile/index";
// import UploadFileContent from "../UploadFileContent";
import dp from "assets/images/homepage/ySafe/tableIcons/DP.svg";
import CircleLoading from "components/CircleLoading/index";
import RestoreModal from "components/RestoreModal/index";
import { useToast } from "components/Toaster/index";
import TableTest from "../table/TableTest";
import { signupContext } from "context/SignupContext";
import { format } from "date-fns";
import {
  Folder as IzFolder,
  sendAddPin,
  File as IzFile,
  Task,
  Item,
  ManageUser as MU,
  Organization
} from "@induz/sdk";
import {
  generateImageThumbnail,
  generateVideoThumbnail,
  generatePdfThumbnail
} from "../../../../utils/thumbnailGenerator";
import { formatFileSize } from "constants/Common/formatFileSize";
import { ensureFileType } from "utils/fileTypeHelper";

const CHUNK_TIMEOUT = 60000; // 60s per 4MB chunk
const MAX_CHUNK_RETRIES = 3;

// Only these extensions get thumbnail generation — everything else is skipped.
const THUMB_IMAGE_EXTS = new Set([
  "jpg",
  "jpeg",
  "png",
  "gif",
  "webp",
  "bmp",
  "ico",
  "avif",
  "heic",
  "heif",
  "hiec"
]);
const THUMB_VIDEO_EXTS = new Set([
  "mp4",
  "webm",
  "ogg",
  "mov",
  "avi",
  "mkv",
  "m4v",
  "3gp"
]);

// Returns "image" | "video" | "pdf" | null
const getThumbnailType = (file) => {
  const ext = (file.name || "").split(".").pop().toLowerCase();
  if (THUMB_IMAGE_EXTS.has(ext)) return "image";
  if (THUMB_VIDEO_EXTS.has(ext)) return "video";
  if (ext === "pdf") return "pdf";
  return null;
};

const withTimeout = (promise, ms, label = "Operation") => {
  let timeoutId;
  const timeoutPromise = new Promise((_, reject) => {
    timeoutId = setTimeout(
      () => reject(new Error(`${label} timed out after ${ms}ms`)),
      ms
    );
  });
  return Promise.race([promise, timeoutPromise]).finally(() =>
    clearTimeout(timeoutId)
  );
};

// Helpers for owner profile pictures (no layout/row/column changes)
const detectImageMimeType = (bytes) => {
  if (!bytes || bytes.length < 4) return "image/png";
  const s = Array.from(bytes.slice(0, 12));
  if (s[0] === 0x89 && s[1] === 0x50 && s[2] === 0x4e && s[3] === 0x47)
    return "image/png";
  if (s[0] === 0xff && s[1] === 0xd8 && s[2] === 0xff) return "image/jpeg";
  if (s[0] === 0x47 && s[1] === 0x49 && s[2] === 0x46) return "image/gif";
  if (
    s[0] === 0x52 &&
    s[1] === 0x49 &&
    s[2] === 0x46 &&
    s[3] === 0x46 &&
    s[8] === 0x57 &&
    s[9] === 0x45 &&
    s[10] === 0x42 &&
    s[11] === 0x50
  )
    return "image/webp";
  return "image/png";
};
const normalizeBytes = (bytes) => {
  if (!bytes) return null;
  if (bytes instanceof Uint8Array) return bytes;
  if (bytes instanceof ArrayBuffer) return new Uint8Array(bytes);
  if (Array.isArray(bytes)) return Uint8Array.from(bytes);
  return null;
};
const uint8ToBase64 = (u8) => {
  const chunkSize = 0x8000;
  let binary = "";
  for (let i = 0; i < u8.length; i += chunkSize) {
    const chunk = u8.subarray(i, i + chunkSize);
    binary += String.fromCharCode.apply(null, chunk);
  }
  return btoa(binary);
};
const bytesToDataUrl = (bytes) => {
  const u8 = normalizeBytes(bytes);
  if (!u8 || u8.length === 0) return null;
  const base64 = uint8ToBase64(u8);
  const mime = detectImageMimeType(u8);
  return `data:${mime};base64,${base64}`;
};
const normalizeOwnerKey = (email) =>
  (email || "").toString().trim().toLowerCase();

const options = ["Name", "Type", "File Size", "Created Date", "Modified Date"];
const actionIconTitles = [
  "moveTo",
  "copy",
  "favorite",
  "download",
  "share",
  "restore",
  "delete"
];

// eslint-disable-next-line react/display-name
const FilesWrapper = forwardRef(
  (
    {
      TaskMonitorVisible,
      setTaskMonitorVisible,
      filesList,
      setFilesList,
      modal,
      setModal,
      uploadModal,
      setUploadModal,
      folder,
      uploadedFiles,
      setUploadedFiles,
      setIsDropDownVisible,
      isDropDownVisible,
      setShowLoadingProgress,
      showLoadingProgress,
      cancelUploadModal,
      setCancelUploadModal,
      fetchData,
      selectedFile,
      setSelectedFile,
      progress,
      setProgress,
      timeRemaining,
      setTimeRemaining,
      data,
      setCurrentPath,
      currentPath,
      path,
      checkedRows,
      setCheckedRows,
      namesArrays,
      typesArrays,
      sizeArrays,
      modifiedArrays,
      ownerArrays,
      setShowingSection,
      setShow,
      showUplodOptionsFunciton,
      uploadFolder,
      setUploadFolder,
      UUIDArrays,
      taskManager,
      searchQuery,
      sortSelected,
      isSortRotated,
      setIsSortRotated,
      layout,
      setLayout,
      currentPage,
      setCurrentPage,
      totalPages,
      listedFolders,
      getReanderingList,
      showSharedTab = true,
      itemsPerPage,
      backendOperations,
      isOrganisationUser,
      hasSpacePermission = true
    },
    ref
    // { isVisible, handleCancel }
  ) => {
    //   const [active, setActive] = useState(0);
    const [activeTab, setActiveTab] = useState(0);

    const [menu, setMenu] = useState({
      selectedRow: null,
      selectedOption: ""
    });

    const onChangeSection = (index) => {
      setCheckedRows({});
      setCurrentPath([]);
      setShowingSection(index);
      setActiveTab(index);
      setFilesData([]);
      if (typeof setCurrentPage === "function") {
        setCurrentPage(1);
      }
      // Notify homepage header about tab change so it can update icon highlight
      try {
        window.dispatchEvent(
          new CustomEvent("filesTabChanged", { detail: index })
        );
      } catch (_) {
        void 0;
      }
    };

    useEffect(() => {
      // setSelectedFile(null);
      setProgress(0);
      setTimeRemaining(0);
      setModal(false);
    }, []);

    const currentPathRef = useRef(currentPath);
    useLayoutEffect(() => {
      currentPathRef.current = currentPath;
      setFilesData([]); // Clear local data on navigation to prevent flicker
    }, [currentPath, activeTab]);
    // const [filesData] = useState(dummyData);

    const [filesData, setFilesData] = useState([]); // test
    const [ownerProfileImages, setOwnerProfileImages] = useState({}); // email -> profile/logo data URL (no layout change)

    // Fetch owner profile/logo for table Owner column (same as header/Settings: org=logo, user=profile)
    useEffect(() => {
      if (!Array.isArray(ownerArrays) || ownerArrays.length === 0) {
        setOwnerProfileImages({});
        return;
      }
      const currentUserMail = sessionStorage.getItem("mail") || "";
      const uniqueEmails = [
        ...new Set(
          ownerArrays
            .map((o) =>
              o === "you" ? currentUserMail : (o || "").toString().trim()
            )
            .filter(Boolean)
        )
      ];
      let cancelled = false;
      const next = {};
      Promise.all(
        uniqueEmails.map(async (email) => {
          if (!email || cancelled) return;
          try {
            const details = await MU.getUserDetails(email, false);
            const picBytes =
              details instanceof Organization
                ? details?.getLogo?.()
                : details?.getProfilePicture?.();
            const dataUrl = bytesToDataUrl(picBytes);
            if (dataUrl && !cancelled) next[normalizeOwnerKey(email)] = dataUrl;
          } catch (_) {
            /* ignore */
          }
        })
      ).then(() => {
        if (!cancelled) setOwnerProfileImages((prev) => ({ ...prev, ...next }));
      });
      return () => {
        cancelled = true;
      };
    }, [ownerArrays]);

    // When Shared tab is hidden (Individual user), reset from Shared (1) to Own (0)
    useEffect(() => {
      if (showSharedTab === false && activeTab === 1) {
        setActiveTab(0);
        setShowingSection(0);
        setCurrentPath([]);
        try {
          window.dispatchEvent(
            new CustomEvent("filesTabChanged", { detail: 0 })
          );
        } catch (_) {
          /* ignore */
        }
      }
    }, [showSharedTab, activeTab, setShowingSection, setCurrentPath]);

    useEffect(() => {
      setCheckedRows({});
      // const namesArrays = JSON.parse(data?.get_obect_names());
      // const typesArrays = JSON.parse(data?.get_type());
      // check if names array is deined type
      if (
        !Array.isArray(namesArrays) ||
        !Array.isArray(typesArrays) ||
        !Array.isArray(sizeArrays) ||
        !Array.isArray(modifiedArrays) ||
        !Array.isArray(ownerArrays) ||
        !Array.isArray(UUIDArrays)
      ) {
        setFilesData([]);
        return;
      }
      if (namesArrays.length === 0) {
        setFilesData([]);
        return;
      }
      // console.log("inside setchecked rows and uuidsarray is ", UUIDArrays);
      const ownerKeyForImg = (idx) =>
        normalizeOwnerKey(
          ownerArrays[idx] === "you"
            ? sessionStorage.getItem("mail") || ""
            : (ownerArrays[idx] || "").toString().trim()
        );
      const dataReceiveds = namesArrays.map((name, index) => ({
        name,
        type: typesArrays[index],
        size: sizeArrays[index],
        last_modified_date: modifiedArrays[index],
        owner: ownerArrays[index],
        uuids: UUIDArrays[index],
        img: ownerProfileImages[ownerKeyForImg(index)] ?? null,
        fo: data?.[index] ?? null
      }));
      setFilesData(dataReceiveds);
    }, [data, ownerProfileImages]);

    const [selectedModal, setSelectedModal] = useState(null);
    const [selectedRow, setSelectedRow] = useState({});
    const { storageBalance } = useContext(signupContext);

    const filteredFilesData = Object.keys(checkedRows)
      .map((name) => filesData.find((item) => item.name == name))
      .filter(Boolean);
    const filteredFilesNames = (checkedRows) => {
      const filteredFilesData = Object.keys(checkedRows)
        .map((name) => filesData.find((item) => item.name == name))
        .filter(Boolean);
      return filteredFilesData;
    };

    const sortFiles = useCallback(() => {
      if (!sortSelected) return;

      setFilesData((prevFiles) => {
        // return fetchData(currentPath, selected);
        return [...prevFiles].sort((a, b) => {
          if (sortSelected === "Type") {
            // Prioritize folders first
            const isAFolder = a.isFolder ? 1 : 0;
            const isBFolder = b.isFolder ? 1 : 0;

            if (isAFolder !== isBFolder) {
              return isBFolder - isAFolder; // Folders first
            }

            // Extract extensions, if missing set it to an empty string
            const extA = a.name.includes(".")
              ? a.name.split(".").pop().toLowerCase()
              : "";
            const extB = b.name.includes(".")
              ? b.name.split(".").pop().toLowerCase()
              : "";

            // Files without an extension should be at the top (after folders)
            if (extA === "" && extB !== "") return -1;
            if (extA !== "" && extB === "") return 1;

            // Sort by file extension
            const comparison = extA.localeCompare(extB);

            return isSortRotated ? -comparison : comparison;
          }

          let comparison = 0;
          // Compare based on the selected criteria

          if (sortSelected === "Name") {
            comparison = a.name.localeCompare(b.name);
          } else if (sortSelected === "Modified Date") {
            comparison = new Date(a.last_modified) - new Date(b.last_modified);
          } else if (sortSelected === "File Size") {
            comparison = parseFloat(a.size) - parseFloat(b.size);
          } else if (sortSelected === "Created Date") {
            comparison = new Date(a.created_at) - new Date(b.created_at);
          }

          return isSortRotated ? -comparison : comparison;
        });
      });
    }, [sortSelected, isSortRotated]);

    useEffect(() => {
      fetchData(path, sortSelected);
    }, [sortSelected, isSortRotated, sortFiles]);

    useEffect(() => {
      if (!currentPath) return;

      if (
        !Array.isArray(namesArrays) ||
        !Array.isArray(typesArrays) ||
        !Array.isArray(sizeArrays) ||
        !Array.isArray(modifiedArrays) ||
        !Array.isArray(ownerArrays)
      ) {
        setFilesData([]);
        return;
      }
      if (namesArrays.length === 0) {
        setFilesData([]);
        return;
      }
      const ownerKeyForImg = (idx) =>
        normalizeOwnerKey(
          ownerArrays[idx] === "you"
            ? sessionStorage.getItem("mail") || ""
            : (ownerArrays[idx] || "").toString().trim()
        );
      const newData = namesArrays.map((name, index) => ({
        name,
        type: typesArrays[index],
        size: sizeArrays[index],
        last_modified_date: modifiedArrays[index],
        owner: ownerArrays[index],
        uuids: UUIDArrays[index],
        img: ownerProfileImages[ownerKeyForImg(index)] ?? null,
        fo: data?.[index] ?? null
      }));

      newData.sort((a, b) => {
        if (a.type === "folder" && b.type !== "folder") return -1;
        if (a.type !== "folder" && b.type === "folder") return 1;
        return 0; // Maintain relative order otherwise
      });
      setFilesData(newData);
    }, [currentPath, data, ownerProfileImages]); // Dependencies: currentPath and data

    useEffect(() => {
      // Reset sorting selection when path changes
      // Note: We can't directly set the parent state here, so we'll handle this in the parent component
    }, [currentPath]);

    const [count, setCount] = useState(0);
    const [AddFile, setAddFile] = useState(false);

    const theme = useTheme();
    const isMobile = useScreenMobile({ size: 768 });

    // Register the add file handler with the homepage (similar to ManageUser)
    // This useEffect will be moved after fetchDataWithFollowups definition

    // handleAddFile function removed - Add button now handled in homepage

    // const saveHandler = () => {
    //   setUploadModal(true);
    //   setModal(false);
    // };

    const showToast = useToast();

    useEffect(() => {
      setIsDropDownVisible(false);
    }, []);

    const dropdownRef = useRef(null);

    // Click outside handler removed - dropdown now handled in homepage

    const hasTrueValue = Object.values(checkedRows).some((value) => value);
    const { userMail } = useContext(signInContext);
    const addPin = async () => {
      const pin = "642355";
      const token = await sendAddPin(userMail, pin);
      // console.log("token is ", token);
      return {
        token: token,
        pin: pin
      };
    };

    // Track active concurrent uploads globally for logging
    const activeUploadCount = { current: 0 };

    const uploadFile = async (
      file,
      parentPath,
      customName = null,
      onProgress = null,
      suppressTask = false,
      suppressRefresh = false,
      thumbnailPromise = null,
      suppressToast = false,
      cancelFlag = null,
      masterTaskRef = null
    ) => {
      activeUploadCount.current++;

      const chunkSize = 4 * 1024 * 1024;
      const totalChunks = Math.ceil(file.size / chunkSize);
      const fo = new IzFile();

      fo.setSize(file.size);
      fo.setParentPath(parentPath);
      const displayName = customName || file.name;
      const displayTaskName = file.originalName || displayName;
      fo.setFileName(displayName);

      if (!parentPath.endsWith("/")) parentPath += "/";

      let uploadedBytes = 0;
      let task = null;
      if (!suppressTask) {
        task = new Task(file.size, displayTaskName, "Uploading ");
        taskManager.addRunningTask(task);
      } else {
        task = new Task(file.size, displayTaskName, "Uploading ");
      }

      try {
        // Try startWrite with original name, retry with normalized name on failure
        try {
          await withTimeout(fo.startWrite(file.type), 30000, "startWrite");
        } catch (startErr) {
          const originalName = customName || file.name;
          const normalizedName = normalizeName(originalName, true);
          if (normalizedName !== originalName) {
            console.warn(
              `startWrite failed for "${originalName}", retrying with normalized name "${normalizedName}"`
            );
            fo.setFileName(normalizedName);
            await withTimeout(
              fo.startWrite(file.type),
              30000,
              "startWrite (normalized)"
            );
          } else {
            throw startErr;
          }
        }

        let errorOccurred = null;
        const maxConcurrency = Math.max(
          2,
          Math.floor(8 / activeUploadCount.current)
        );

        // Helper: upload 2 chunks on the SAME connection via putChunks
        const uploadChunkPair = async (offsets) => {
          if (errorOccurred) return;
          const chunks = [];
          for (const start of offsets) {
            const chunk = file.slice(start, start + chunkSize);
            const arrayBuffer = await chunk.arrayBuffer();
            chunks.push({ data: new Uint8Array(arrayBuffer), offset: start });
          }

          for (let attempt = 0; attempt <= MAX_CHUNK_RETRIES; attempt++) {
            try {
              await withTimeout(
                fo.putChunks(chunks, task, null),
                CHUNK_TIMEOUT * chunks.length,
                `Upload ${chunks.length} chunks`
              );

              // Track progress after successful upload
              const uploadedChunkBytes = offsets.reduce((sum, start) => {
                return sum + Math.min(chunkSize, file.size - start);
              }, 0);
              const delta = Math.min(
                uploadedChunkBytes,
                file.size - uploadedBytes
              );
              uploadedBytes += delta;
              if (onProgress) onProgress(delta);

              return;
            } catch (err) {
              if (attempt < MAX_CHUNK_RETRIES) {
                const delay = Math.min(1000 * Math.pow(2, attempt), 8000);
                await new Promise((r) => setTimeout(r, delay));
                continue;
              }
              errorOccurred = err;
              throw err;
            }
          }
        };

        // Build all chunk pair offset groups upfront
        const pairGroups = [];
        for (let offset = 0; offset < file.size; offset += chunkSize * 2) {
          if (cancelFlag?.cancelled || masterTaskRef?.getStatus?.() === 3) {
            throw new Error("Upload cancelled");
          }
          const offsets = [];
          // Each group has up to 2 chunk offsets
          for (let i = 0; i < 2 && offset + i * chunkSize < file.size; i++) {
            offsets.push(offset + i * chunkSize);
          }
          pairGroups.push(offsets);
        }

        // Process in strict batches of maxConcurrency
        for (let i = 0; i < pairGroups.length; i += maxConcurrency) {
          if (cancelFlag?.cancelled || masterTaskRef?.getStatus?.() === 3) {
            throw new Error("Upload cancelled");
          }
          if (errorOccurred) throw errorOccurred;

          const batch = pairGroups.slice(i, i + maxConcurrency);

          await Promise.all(batch.map((offsets) => uploadChunkPair(offsets)));

          if (errorOccurred) throw errorOccurred;
        }

        let fileType = file.type;
        await withTimeout(
          fo.finalizeWrite(fileType, [], file.size),
          30000,
          "finalizeWrite"
        );

        // Apply thumbnail after upload completes (generated concurrently)
        if (thumbnailPromise) {
          try {
            const thumbnailBytes = await thumbnailPromise;
            if (thumbnailBytes) {
              const isShared =
                currentPath.length > 0 && currentPath[0] === "shared";
              if (typeof fo.setThumbnail === "function") {
                await fo.setThumbnail(thumbnailBytes, !isShared);
              } else {
                console.warn(
                  "fo.setThumbnail is not a function. Skipping thumbnail upload."
                );
              }
            }
          } catch (thumbnailErr) {
            console.error("Failed to set thumbnail:", thumbnailErr);
          }
        }

        if (!suppressTask) {
          task.progress = 100;
          taskManager.addCompletedTask(task, 1);

          const isSamePath =
            (currentPathRef.current || []).join("/") ===
            (currentPath || []).join("/");
          if (isSamePath && !suppressRefresh) {
            fetchDataWithFollowups(currentPathRef.current);
          }
        }
      } catch (error) {
        if (!suppressTask) {
          if (error.message === "Upload cancelled") {
            task.name = `Cancelled — ${file.name} upload`;
            taskManager.addCompletedTask(task, 3);
          } else {
            taskManager.addCompletedTask(task, 2);
          }
        }
        if (cancelUploadModal) {
          if (!suppressToast) showToast("Upload cancelled", "success");
        } else {
          if (!suppressToast)
            showToast(`Upload failed for ${file.name}`, "error");
        }
        throw error;
      } finally {
        activeUploadCount.current--;
      }
    };

    function extractParentAndName(path) {
      //  console.log("Create folder",path);
      const lastSlash = path.lastIndexOf("/");
      if (lastSlash === -1) {
        return { parent: "", name: path };
      }
      const parent = path.substring(0, lastSlash);
      const name = path.substring(lastSlash + 1);
      return { parent, name };
    }

    const activeDirCount = { current: 0 };

    async function createDirectory(
      total_path,
      formattedPath,
      shouldFetch = true,
      suppressTask = false
    ) {
      activeDirCount.current++;
      let localPath = [...path];
      if (localPath[1] === "self" && localPath[0] == "shared") {
        localPath.splice(1, 1);
      }

      const now = new Date();
      const formattedDateTime = format(now, "M/d/yyyy h:mm a"); // Uses Date-fns
      const { parent, name } = extractParentAndName(total_path);

      let folderTask = null;
      if (!suppressTask) {
        folderTask = new Task(0, `Creating ${name}`, "Creating");
        taskManager.addRunningTask(folderTask);
      }

      try {
        const root = new IzFolder();
        const folderLocation = parent
          ? formattedPath + "/" + parent
          : formattedPath;
        await root.createFolder(folderLocation, name);

        if (!suppressTask && folderTask) {
          folderTask.progress = 100;
          taskManager.addCompletedTask(folderTask, 1);
        }

        if (shouldFetch) {
          // Only refresh if we are still in the same folder
          const isSamePath =
            (currentPathRef.current || []).join("/") ===
            (currentPath || []).join("/");
          if (isSamePath) {
            fetchDataWithFollowups(currentPathRef.current);
          }
        }

        setIsDropDownVisible(false);
        setAddFile(false);
      } catch (error) {
        if (!suppressTask && folderTask) {
          taskManager.addCompletedTask(folderTask, 2);
        }
        console.error("Failed to create folder:", error);
        if (!suppressTask) {
          showToast("Failed to create Folder", "error");
        }
        throw error;
      } finally {
        activeDirCount.current--;
      }
    }
    //     async function saveHandlerForSharedFiles(selectedFiles) {
    //   setTaskMonitorVisible(true);
    //   const formattedPath = currentPath?.length === 0 ? "/" : `/${currentPath?.join("/")}`;
    //   try {
    //     setUploadModal(true);
    //     setModal(false);
    //     if (uploadFolder) {
    //       const directories = new Set();
    //       for (const file of selectedFiles) {
    //         const parts = file.webkitRelativePath.split("/");
    //         let curr = "";

    //         for (let i = 0; i < parts.length - 1; i++) {
    //           curr += (i === 0 ? "" : "/") + parts[i];
    //           directories.add(curr);
    //         }
    //       }

    //       for (const x of directories) {
    //         await createDirectory(x, formattedPath);
    //       }
    //     }

    //     const uploadPromises = [];

    //     for (const file of selectedFiles) {
    //       if (cancelUploadModal) {
    //         console.warn("Upload cancelled before starting.");
    //         showToast("Upload cancelled", "warning");
    //         break;
    //       }

    //       const path = uploadFolder
    //         ? (formattedPath.endsWith("/") ? formattedPath : formattedPath + "/") +
    //         file.webkitRelativePath.substring(0, file.webkitRelativePath.lastIndexOf("/"))
    //         : formattedPath;

    //       const uploadPromise = uploadFile(file, path).catch(error => {
    //         // Optional: handle specific error or cancellation
    //         console.error("Upload failed for", file.name, error);
    //         // Decide whether to throw or just log
    //         throw error; // if you want to halt Promise.allSettled loop later
    //       });

    //       uploadPromises.push(uploadPromise);
    //     }

    //     try {
    //       await Promise.allSettled(uploadPromises); // Or use Promise.all() to fail fast

    //     } catch (error) {
    //       console.warn("One or more uploads failed:", error);
    //     }

    //     setUploadModal(false);
    //     setSelectedFile([]);
    //     setFilesList([]);
    //     fetchDataWithFollowups(currentPath); // refresh view
    //     if (!cancelUploadModal && storageBalance > 90) {
    //       setShow(true);
    //     }

    //     // if (!cancelUploadModal) {
    //     //   showToast("Files uploaded successfully", "success");
    //     // }
    //   } catch (error) {
    //     console.error("Error occurred during upload:", error);
    //     showToast(
    //       error?.message || "Error occurred while uploading files",
    //       "error"
    //     );
    //   }
    // }

    async function saveHandler(selectedFiles) {
      setTaskMonitorVisible(true);
      window.dispatchEvent(new CustomEvent("operationStart"));

      // --- Quick filter: remove dot files/directories, gather directory paths ---
      const filteredFiles = [];
      const directories = new Set();
      const isFolder = uploadFolder;

      for (const f of selectedFiles) {
        if (isFolder) {
          if (f.webkitRelativePath.split("/").some((p) => p.startsWith(".")))
            continue;
        } else {
          if (f.name.startsWith(".")) continue;
        }
        filteredFiles.push(f);

        if (isFolder) {
          const relativePath = f.webkitRelativePath || f.name;
          const parts = relativePath.split("/");
          let curr = "";
          for (let j = 0; j < parts.length - 1; j++) {
            curr += (j === 0 ? "" : "/") + parts[j];
            directories.add(curr);
          }
        }
      }

      selectedFiles = filteredFiles;
      if (selectedFiles.length === 0) {
        window.dispatchEvent(new CustomEvent("operationEnd"));
        return;
      }

      let dupCurrentPath = currentPath;
      let pathForTeamSharing = currentPath;
      if (
        dupCurrentPath.length >= 2 &&
        dupCurrentPath[0] == "shared" &&
        dupCurrentPath[1] == "teams"
      ) {
        const newPath = [...dupCurrentPath];
        newPath.splice(1, 3);
        dupCurrentPath = newPath;
      } else if (dupCurrentPath.length >= 2 && dupCurrentPath[0] == "shared") {
        const newPath = [...dupCurrentPath];
        newPath.splice(1, 1);
        dupCurrentPath = newPath;
      }
      const formattedPath =
        dupCurrentPath?.length === 0 ? "/" : `/${dupCurrentPath?.join("/")}`;

      // Single master task covers all folder creations + file uploads for this operation
      const rawTopFolder =
        uploadFolder && selectedFiles.length > 0
          ? (selectedFiles[0].webkitRelativePath || "").split("/")[0]
          : null;
      const taskLabel = rawTopFolder
        ? rawTopFolder
        : filteredFiles.length === 1
          ? filteredFiles[0].originalName || filteredFiles[0].name
          : `${filteredFiles.length} files`;
      const totalBytes = isFolder
        ? 0
        : filteredFiles.reduce((sum, f) => sum + (f.size || 0), 0);
      const masterTask = new Task(filteredFiles.length, taskLabel, "Uploading");
      taskManager.addRunningTask(masterTask);
      let uploadedBytes = 0;
      let failedCount = 0;
      const uploadStartTime = Date.now();
      let lastProgressUpdate = 0;

      try {
        setUploadModal(true);
        setModal(false);
        // Maps original dir path → actual created dir path (handles normalization)
        const resolvedPaths = new Map();
        if (uploadFolder) {
          // Sort by depth so parent directories are always created before their children
          const sortedDirectories = Array.from(directories).sort(
            (a, b) => a.split("/").length - b.split("/").length
          );
          const failedDirectories = new Set();

          // Group by depth level for batch creation (parents before children)
          const dirsByDepth = new Map();
          for (const dir of sortedDirectories) {
            const depth = dir.split("/").length;
            if (!dirsByDepth.has(depth)) dirsByDepth.set(depth, []);
            dirsByDepth.get(depth).push(dir);
          }

          let dirsCreated = 0;
          const totalDirs = sortedDirectories.length;
          if (totalDirs > 0) {
            masterTask.taskDescription = `Creating folders (0/${totalDirs})...`;
          }

          const DIR_BATCH = 6;
          const batchFolder = new IzFolder().getRoot();
          const depthLevels = Array.from(dirsByDepth.keys()).sort(
            (a, b) => a - b
          );
          for (const depth of depthLevels) {
            const dirsAtLevel = dirsByDepth.get(depth);

            // Filter out dirs whose parent failed
            const toCreate = [];
            // Track (parentPath + normalizedName) to detect collisions at this depth
            const seenAtLevel = new Map(); // key: "parentPath/normalizedName" → first dir that claimed it
            for (const dir of dirsAtLevel) {
              const isParentFailed = Array.from(failedDirectories).some((fd) =>
                dir.startsWith(fd + "/")
              );
              if (isParentFailed) {
                failedDirectories.add(dir);
                dirsCreated++;
              } else {
                const { parent, name } = extractParentAndName(dir);
                const resolvedParent = parent
                  ? resolvedPaths.get(parent) || parent
                  : "";
                const folderLocation = resolvedParent
                  ? (formattedPath.endsWith("/")
                      ? formattedPath
                      : formattedPath + "/") + resolvedParent
                  : formattedPath;
                let normalizedName = normalizeName(name, false);

                // Detect collision: another dir at this level already maps to the same normalized name + parent
                const collisionKey = folderLocation + "/" + normalizedName;
                if (seenAtLevel.has(collisionKey)) {
                  // Append suffix to differentiate: name_1, name_2, etc.
                  let suffix = 1;
                  let uniqueName = normalizedName + "_" + suffix;
                  while (seenAtLevel.has(folderLocation + "/" + uniqueName)) {
                    suffix++;
                    uniqueName = normalizedName + "_" + suffix;
                  }
                  normalizedName = uniqueName;
                  seenAtLevel.set(folderLocation + "/" + normalizedName, dir);
                } else {
                  seenAtLevel.set(collisionKey, dir);
                }
                toCreate.push({
                  parentPath: folderLocation,
                  folderName: normalizedName,
                  dir,
                  resolvedParent
                });
              }
            }

            if (toCreate.length > 0) {
              for (let i = 0; i < toCreate.length; i += DIR_BATCH) {
                const chunk = toCreate.slice(i, i + DIR_BATCH);
                const chunkResults = await batchFolder.createFolders(
                  chunk.map(({ parentPath, folderName }) => ({
                    parentPath,
                    folderName
                  }))
                );

                for (let r = 0; r < chunkResults.length; r++) {
                  const rp = chunk[r].resolvedParent;
                  if (chunkResults[r].success) {
                    resolvedPaths.set(
                      chunk[r].dir,
                      rp ? rp + "/" + chunk[r].folderName : chunk[r].folderName
                    );
                  } else {
                    failedDirectories.add(chunk[r].dir);
                  }
                  dirsCreated++;
                }
                masterTask.taskDescription = `Creating folders (${dirsCreated}/${totalDirs})...`;
              }
            }
          }
          masterTask.taskDescription = taskLabel;
        }

        // Upload files with a concurrency limit to utilize all connections.
        // All directories above are fully created before any file upload starts.
        const concurrencyLimit = 6;
        const activePromises = [];
        const results = [];
        let cancelled = false;
        let filesStarted = 0;
        let filesCompleted = 0;
        const totalFileCount = selectedFiles.length;

        for (const file of selectedFiles) {
          // Check if user cancelled via TaskMonitor
          if (masterTask.getStatus() === 3) {
            cancelled = true;
            break;
          }

          while (activePromises.length >= concurrencyLimit) {
            await Promise.race(activePromises);
          }

          // Check again after awaiting (user may have cancelled while waiting)
          if (masterTask.getStatus() === 3) {
            cancelled = true;
            break;
          }

          filesStarted++;

          let filePath;
          let fileName;

          if (uploadFolder) {
            // Fallback: if webkitRelativePath is missing, use file.name directly
            const relativePath = file.webkitRelativePath || file.name;
            const parts = relativePath.split("/");
            const dirParts = parts.slice(0, parts.length - 1);
            fileName = normalizeName(parts[parts.length - 1], true);
            const fileDir = dirParts.join("/");

            // Skip files whose parent directory failed to create
            if (resolvedPaths.size > 0 && !resolvedPaths.has(fileDir)) {
              console.warn(
                "Skipping file (parent folder failed):",
                file.webkitRelativePath
              );
              failedCount++;
              continue;
            }

            const resolvedDir = resolvedPaths.get(fileDir) || fileDir;
            filePath =
              (formattedPath.endsWith("/")
                ? formattedPath
                : formattedPath + "/") + resolvedDir;
          } else {
            filePath = formattedPath;
            fileName = normalizeName(file.name, true);
          }

          const promise = (async () => {
            // Start thumbnail generation concurrently — only for supported types
            const thumbType = getThumbnailType(file);
            const thumbnailPromise = thumbType
              ? (async () => {
                  try {
                    let thumbnailBlob = null;
                    if (thumbType === "image")
                      thumbnailBlob = await generateImageThumbnail(file);
                    else if (thumbType === "video")
                      thumbnailBlob = await generateVideoThumbnail(file);
                    else if (thumbType === "pdf")
                      thumbnailBlob = await generatePdfThumbnail(file);
                    if (thumbnailBlob)
                      return new Uint8Array(await thumbnailBlob.arrayBuffer());
                  } catch (e) {
                    console.warn(
                      "Failed to generate thumbnail for",
                      file.name,
                      e
                    );
                  }
                  return null;
                })()
              : null;

            return uploadFile(
              file,
              filePath,
              fileName,
              (deltaBytes) => {
                uploadedBytes += deltaBytes;
                masterTask.progress =
                  totalBytes > 0
                    ? Math.min((uploadedBytes / totalBytes) * 100, 99)
                    : 0;
                const now = Date.now();
                if (now - lastProgressUpdate > 500) {
                  lastProgressUpdate = now;
                }
              },
              true, // suppressTask — individual file tasks hidden under master task
              true, // suppressRefresh
              thumbnailPromise,
              true, // suppressToast — folder upload shows summary toast instead
              null, // cancelFlag
              masterTask // masterTaskRef — chunk loop checks this to detect cancellation
            );
          })().then(
            () => {
              filesCompleted++;
              masterTask.progress =
                totalBytes > 0
                  ? Math.min((uploadedBytes / totalBytes) * 100, 99)
                  : 0;
              const idx = activePromises.indexOf(promise);
              if (idx > -1) activePromises.splice(idx, 1);
            },
            (err) => {
              if (err?.message === "Upload cancelled") {
                cancelled = true;
              } else {
                failedCount++;
              }
              const idx = activePromises.indexOf(promise);
              if (idx > -1) activePromises.splice(idx, 1);
            }
          );

          activePromises.push(promise);
          results.push(promise);
        }

        // Wait for in-flight uploads to finish even if cancelled
        await Promise.all(results);

        if (cancelled) {
          masterTask.name = `Cancelled — ${filesCompleted} of ${selectedFiles.length} uploaded`;
          masterTask.taskDescription = `Cancelled — ${filesCompleted} of ${selectedFiles.length} files uploaded`;
          taskManager.addCompletedTask(masterTask, 3);
        } else {
          masterTask.progress = 100;
          if (failedCount > 0 && String(masterTask.name).includes("files")) {
            masterTask.name = `${Math.max(0, selectedFiles.length - failedCount)} files, ${failedCount} failed`;
          }
          taskManager.addCompletedTask(masterTask, failedCount > 0 ? 2 : 1);
          if (failedCount > 0) {
            showToast(
              `${failedCount} file${failedCount > 1 ? "s" : ""} failed to upload`,
              "error"
            );
          }
        }

        setUploadModal(false);
        setSelectedFile([]);
        setFilesList([]);

        // Only refresh if we are still in the same folder
        const isSamePath =
          (currentPathRef.current || []).join("/") ===
          (currentPath || []).join("/");
        if (isSamePath) {
          fetchDataWithFollowups(currentPathRef.current); // refresh view
        }

        if (!cancelled) {
          window.dispatchEvent(new CustomEvent("storageUpdated"));
        }
        if (!cancelled && storageBalance > 90) {
          setShow(true);
        }

        // if (!cancelUploadModal) {
        //   showToast("Files uploaded successfully", "success");
        // }
      } catch (error) {
        taskManager.addCompletedTask(masterTask, 2);
        console.error("Error occurred during upload:", error);
        showToast(
          error?.message || "Error occurred while uploading files",
          "error"
        );
      } finally {
        window.dispatchEvent(new CustomEvent("operationEnd"));
      }
    }

    const checkTheExistenceOfFile = async () => {
      try {
        let itemInTeamSharing = false;
        let dupCurrentPath = path;
        if (
          dupCurrentPath.length >= 2 &&
          dupCurrentPath[0] === "shared" &&
          dupCurrentPath[1] !== "self"
        ) {
          itemInTeamSharing = true;
        }

        if (dupCurrentPath[0] === "shared" && dupCurrentPath.length >= 2) {
          const newPath = [...dupCurrentPath];
          if (itemInTeamSharing) {
            // Team sharing path: /shared/teams/[teamName]/...
            newPath.splice(1, 0, "teams");
          } else {
            // Personal sharing path: /shared/[folderName]/... (remove "self" virtual segment)
            newPath.splice(1, 1);
          }
          dupCurrentPath = newPath;
        }

        const formattedPath =
          dupCurrentPath?.length === 0 || !dupCurrentPath
            ? "/"
            : `/${dupCurrentPath.join("/")}`;
        const basePath = formattedPath === "/" ? "" : formattedPath;

        // --- FOLDER UPLOAD logic ---
        if (uploadFolder && selectedFile.length > 0) {
          const topFolderName = normalizeName(
            selectedFile[0].webkitRelativePath.split("/")[0],
            false
          );
          const topFolderPath = `${basePath}/${topFolderName}`;
          try {
            await Item.getItem(topFolderPath, false);
            setUploadModal(false);
            showUplodOptionsFunciton([{ name: topFolderName }]);
          } catch {
            saveHandler(selectedFile);
          }
          return;
        }

        // --- FILE UPLOAD logic ---
        // For large uploads, clear modal immediately and show progress in the Operation Panel
        const isLargeUpload = selectedFile.length > 20;
        let preparationTask = null;

        if (isLargeUpload) {
          setModal(false);
          setUploadModal(false);
          setTaskMonitorVisible(true);
          window.dispatchEvent(new CustomEvent("operationStart"));
        }

        const existingFiles = [];
        const missingFiles = [];
        let checkedCount = 0;

        // Concurrency Pool
        const maxConcurrency = 12;
        const activePromises = [];
        const allChecks = [];

        for (const file of selectedFile) {
          const serverFileName = file.name.replace(/\s+/g, "");
          const normalizedFileName = normalizeName(file.name, true);
          const fullPath = `${basePath}/${serverFileName}`;
          const normalizedPath = `${basePath}/${normalizedFileName}`;

          // Throttle
          while (activePromises.length >= maxConcurrency) {
            await Promise.race(activePromises);
          }

          const promise = (async () => {
            try {
              if (
                dupCurrentPath?.length === 1 &&
                dupCurrentPath[0] === "shared"
              ) {
                let full_p = formattedPath;
                const sharedItem = await Item.getSharedItem(
                  full_p + (full_p.endsWith("/") ? "" : "/") + serverFileName,
                  itemInTeamSharing
                );
                const renamedFile = new File([file], sharedItem.getFileUuId(), {
                  type: file.type,
                  lastModified: file.lastModified
                });
                renamedFile.originalName = file.name;
                missingFiles.push(renamedFile);
              } else {
                // Check original filename first; if not found and the name contains special
                // characters that get normalized on upload, also check the normalized name.
                let found = false;
                try {
                  await Item.getItem(fullPath, false);
                  found = true;
                } catch {
                  if (normalizedFileName !== serverFileName) {
                    try {
                      await Item.getItem(normalizedPath, false);
                      found = true;
                    } catch {
                      // not found under either name
                    }
                  }
                }
                if (found) {
                  existingFiles.push(file);
                } else {
                  missingFiles.push(file);
                }
              }
            } catch {
              missingFiles.push(file);
            }
          })();

          activePromises.push(promise);
          allChecks.push(promise);

          promise.finally(() => {
            activePromises.splice(activePromises.indexOf(promise), 1);
            checkedCount++;
          });
        }

        await Promise.all(allChecks);

        if (existingFiles.length > 0) {
          setUploadModal(false);
          showUplodOptionsFunciton(existingFiles);
        }

        if (missingFiles.length > 0) {
          saveHandler(missingFiles);
        }
      } catch (error) {
        console.error("Error occurred while checking file existence:", error);
        showToast(
          error?.message || "Error occurred while checking file existence",
          "error"
        );
      }
    };

    useImperativeHandle(ref, () => ({
      saveHandler
    }));

    const fetchDataWithFollowups = useCallback(
      (path) => {
        // setFilesData([]); // Clear previous data
        fetchData(path);
      },
      [fetchData]
    );

    useEffect(() => {
      const handleFolderUploadEvent = async (event) => {
        const files = event.detail?.files;
        if (!files || files.length === 0) return;

        window.dispatchEvent(new CustomEvent("operationStart"));
        setTaskMonitorVisible(true);

        let mainFolderTask = null;

        try {
          // --- Quick filter: remove dot files, gather directories ---
          const selectedFiles = [];
          const directories = new Set();

          for (const rawFile of files) {
            const file = ensureFileType(rawFile);
            const rp = file.webkitRelativePath || file.name;
            const parts = rp.split("/");

            if (parts.some((part) => part.startsWith("."))) continue;
            selectedFiles.push(file);

            if (parts.length <= 255) {
              let curr = "";
              for (let j = 0; j < parts.length - 1; j++) {
                curr += (j === 0 ? "" : "/") + parts[j];
                directories.add(curr);
              }
            }
          }

          // Signal that we're done reading from the FileList — input can be reset
          window.dispatchEvent(new CustomEvent("folderScanComplete"));

          if (selectedFiles.length === 0) {
            return;
          }

          const sortedDirectories = Array.from(directories).sort(
            (a, b) => a.split("/").length - b.split("/").length
          );

          // --- Path resolution ---
          let dupCurrentPath = [...currentPath];
          if (
            dupCurrentPath.length >= 2 &&
            dupCurrentPath[0] === "shared" &&
            dupCurrentPath[1] !== "self"
          ) {
            // It's a team folder. Insert "teams" at index 1.
            dupCurrentPath.splice(1, 0, "teams");
          } else if (
            dupCurrentPath.length >= 2 &&
            dupCurrentPath[0] === "shared" &&
            dupCurrentPath[1] === "self"
          ) {
            // It's personal shared. Remove "self" virtual segment.
            dupCurrentPath.splice(1, 1);
          } else if (
            dupCurrentPath.length >= 2 &&
            dupCurrentPath[0] === "shared"
          ) {
            // Fallback for other shared items
            dupCurrentPath.splice(1, 1);
          }
          const formattedPath =
            dupCurrentPath?.length === 0
              ? "/"
              : `/${dupCurrentPath?.join("/")}`;

          // --- Master upload task ---
          const rawTopFolder =
            selectedFiles.length > 0
              ? (selectedFiles[0].webkitRelativePath || "").split("/")[0]
              : null;
          const taskLabel = rawTopFolder ? rawTopFolder : "Folder";
          mainFolderTask = new Task(
            selectedFiles.length,
            taskLabel,
            "Uploading"
          );
          taskManager.addRunningTask(mainFolderTask);

          // --- Create directories in batches using SDK batch API ---
          const dirsByDepth = new Map();
          for (const dir of sortedDirectories) {
            const depth = dir.split("/").length;
            if (!dirsByDepth.has(depth)) dirsByDepth.set(depth, []);
            dirsByDepth.get(depth).push(dir);
          }

          // Maps original dir path → actual created dir path (handles normalization retries)
          const resolvedPaths = new Map();
          const failedDirs = new Set();
          let dirsCreated = 0;
          const totalDirs = sortedDirectories.length;
          if (totalDirs > 0) {
            mainFolderTask.taskDescription = `Creating (0/${totalDirs})...`;
          }

          const DIR_BATCH = 6;
          const batchFolder = new IzFolder().getRoot();
          const depthLevels = Array.from(dirsByDepth.keys()).sort(
            (a, b) => a - b
          );
          for (const depth of depthLevels) {
            const dirsAtLevel = dirsByDepth.get(depth);

            // Filter out dirs whose parent failed
            const toCreate = [];
            // Track (parentPath + normalizedName) to detect collisions at this depth
            const seenAtLevel = new Map(); // key: "parentPath/normalizedName" → first dir that claimed it
            for (const dir of dirsAtLevel) {
              const isParentFailed = Array.from(failedDirs).some((fd) =>
                dir.startsWith(fd + "/")
              );
              if (isParentFailed) {
                failedDirs.add(dir);
                dirsCreated++;
              } else {
                const { parent, name } = extractParentAndName(dir);
                const resolvedParent = parent
                  ? resolvedPaths.get(parent) || parent
                  : "";
                const folderLocation = resolvedParent
                  ? (formattedPath.endsWith("/")
                      ? formattedPath
                      : formattedPath + "/") + resolvedParent
                  : formattedPath;
                let normalizedName = normalizeName(name, false);

                // Detect collision: another dir at this level already maps to the same normalized name + parent
                const collisionKey = folderLocation + "/" + normalizedName;
                if (seenAtLevel.has(collisionKey)) {
                  // Append suffix to differentiate: name_1, name_2, etc.
                  let suffix = 1;
                  let uniqueName = normalizedName + "_" + suffix;
                  while (seenAtLevel.has(folderLocation + "/" + uniqueName)) {
                    suffix++;
                    uniqueName = normalizedName + "_" + suffix;
                  }
                  normalizedName = uniqueName;
                  seenAtLevel.set(folderLocation + "/" + normalizedName, dir);
                } else {
                  seenAtLevel.set(collisionKey, dir);
                }
                toCreate.push({
                  parentPath: folderLocation,
                  folderName: normalizedName,
                  dir,
                  resolvedParent
                });
              }
            }

            if (toCreate.length > 0) {
              for (let i = 0; i < toCreate.length; i += DIR_BATCH) {
                const chunk = toCreate.slice(i, i + DIR_BATCH);
                const chunkResults = await batchFolder.createFolders(
                  chunk.map(({ parentPath, folderName }) => ({
                    parentPath,
                    folderName
                  }))
                );

                for (let r = 0; r < chunkResults.length; r++) {
                  const rp = chunk[r].resolvedParent;
                  if (chunkResults[r].success) {
                    resolvedPaths.set(
                      chunk[r].dir,
                      rp ? rp + "/" + chunk[r].folderName : chunk[r].folderName
                    );
                  } else {
                    failedDirs.add(chunk[r].dir);
                  }
                  dirsCreated++;
                }
                mainFolderTask.taskDescription = `Creating (${dirsCreated}/${totalDirs})...`;
              }
            }
          }

          // --- Prepare files for upload ---
          const filesToUpload = [];
          for (const file of selectedFiles) {
            const relativePath = file.webkitRelativePath || file.name;
            const parts = relativePath.split("/");
            if (parts.length > 255) continue;

            const fileDirParts = parts.slice(0, parts.length - 1);
            const fileName = normalizeName(parts[parts.length - 1], true);
            const fileDir = fileDirParts.join("/");

            if (resolvedPaths.size > 0 && !resolvedPaths.has(fileDir)) {
              console.warn(
                "Skipping file (parent folder failed):",
                relativePath
              );
              continue;
            }

            const resolvedDir = resolvedPaths.get(fileDir) || fileDir;
            const uploadPath =
              (formattedPath.endsWith("/")
                ? formattedPath
                : formattedPath + "/") + resolvedDir;
            filesToUpload.push({ file, uploadPath, fileName });
          }

          // --- Upload files concurrently ---
          let totalBytesUploaded = 0;
          const totalBytes = filesToUpload.reduce(
            (acc, item) => acc + item.file.size,
            0
          );
          const uploadStartTime = Date.now();
          let lastProgressUpdate = 0;
          const totalFileCount = filesToUpload.length;
          mainFolderTask.progress = 0;
          mainFolderTask.taskDescription = `0/${totalFileCount} files`;

          const concurrencyLimit = 6;
          const activePromises = [];
          const results = [];

          let cancelled = false;
          const cancelFlag = { cancelled: false };
          let filesStarted = 0;
          let filesCompleted = 0;
          let failedCount = 0;

          for (const item of filesToUpload) {
            // Check if user cancelled via TaskMonitor
            if (mainFolderTask.getStatus() === 3) {
              cancelled = true;
              cancelFlag.cancelled = true;
              break;
            }

            if (activePromises.length >= concurrencyLimit) {
              await Promise.race(activePromises);
            }

            if (mainFolderTask.getStatus() === 3) {
              cancelled = true;
              cancelFlag.cancelled = true;
              break;
            }

            filesStarted++;
            const promise = (async () => {
              // Start thumbnail generation concurrently — only for supported types
              const thumbType = getThumbnailType(item.file);
              const thumbnailPromise = thumbType
                ? (async () => {
                    try {
                      let thumbnailBlob = null;
                      if (thumbType === "image")
                        thumbnailBlob = await generateImageThumbnail(item.file);
                      else if (thumbType === "video")
                        thumbnailBlob = await generateVideoThumbnail(item.file);
                      else if (thumbType === "pdf")
                        thumbnailBlob = await generatePdfThumbnail(item.file);
                      if (thumbnailBlob)
                        return new Uint8Array(
                          await thumbnailBlob.arrayBuffer()
                        );
                    } catch (e) {
                      console.warn(
                        "Failed to generate thumbnail for",
                        item.file.name,
                        e
                      );
                    }
                    return null;
                  })()
                : null;

              return uploadFile(
                item.file,
                item.uploadPath,
                item.fileName,
                (deltaBytes) => {
                  totalBytesUploaded += deltaBytes;
                  mainFolderTask.progress =
                    totalBytes > 0
                      ? Math.min((totalBytesUploaded / totalBytes) * 100, 99)
                      : 0;
                  const now = Date.now();
                  if (now - lastProgressUpdate > 500) {
                    lastProgressUpdate = now;
                  }
                },
                true,
                true,
                thumbnailPromise,
                true, // suppressToast — folder upload shows summary toast instead
                cancelFlag
              );
            })().then(
              (res) => {
                filesCompleted++;
                mainFolderTask.taskDescription = `${filesCompleted}/${totalFileCount} files`;
                mainFolderTask.progress =
                  totalBytes > 0
                    ? Math.min((totalBytesUploaded / totalBytes) * 100, 99)
                    : 0;
                const idx = activePromises.indexOf(promise);
                if (idx > -1) activePromises.splice(idx, 1);
                return { status: "fulfilled", value: res };
              },
              (err) => {
                failedCount++;
                const idx = activePromises.indexOf(promise);
                if (idx > -1) activePromises.splice(idx, 1);
                return { status: "rejected", reason: err };
              }
            );

            activePromises.push(promise);
            results.push(promise);
          }

          if (cancelled) {
            // Signal in-flight uploads to stop sending new chunks
            cancelFlag.cancelled = true;
          }

          // Wait for in-flight uploads to settle (they'll exit early if cancelFlag is set)
          await Promise.allSettled(results);

          if (cancelled) {
            mainFolderTask.name = `Cancelled — ${filesCompleted} of ${filesToUpload.length} uploaded`;
            mainFolderTask.taskDescription = `Cancelled — ${filesCompleted} of ${filesToUpload.length} files uploaded`;
            taskManager.addCompletedTask(mainFolderTask, 3);
          } else {
            mainFolderTask.progress = 100;
            if (
              failedCount > 0 &&
              String(mainFolderTask.name).includes("files")
            ) {
              mainFolderTask.name = `${Math.max(0, filesToUpload.length - failedCount)} files, ${failedCount} failed`;
            }
            taskManager.addCompletedTask(
              mainFolderTask,
              failedCount > 0 ? 2 : 1
            );
            if (failedCount > 0) {
              showToast(
                `${failedCount} file${failedCount > 1 ? "s" : ""} failed to upload`,
                "error"
              );
            }
          }

          const isSamePath =
            (currentPathRef.current || []).join("/") ===
            (currentPath || []).join("/");
          if (isSamePath) {
            fetchDataWithFollowups(currentPathRef.current);
          }
          window.dispatchEvent(new CustomEvent("storageUpdated"));
          if (storageBalance > 90) {
            setShow(true);
          }
        } catch (error) {
          console.error("Folder upload error:", error);
          showToast("Error uploading folder", "error");
          if (mainFolderTask) {
            taskManager.addCompletedTask(mainFolderTask, 2);
          }
        } finally {
          window.dispatchEvent(new CustomEvent("folderScanComplete"));
          window.dispatchEvent(new CustomEvent("operationEnd"));
        }
      };

      window.addEventListener("uploadFolder", handleFolderUploadEvent);
      return () => {
        window.removeEventListener("uploadFolder", handleFolderUploadEvent);
      };
    }, [currentPath, storageBalance, fetchDataWithFollowups]);

    // Register the add file handler with the homepage (similar to ManageUser)
    useEffect(() => {
      window.addFileHandler = () => {
        // Pass all necessary props and functions to the homepage for TextDropDown
        window.filesWrapperProps = {
          setFilesList,
          setModal,
          setUploadedFiles,
          setIsDropDownVisible: setAddFile,
          setAddFile,
          selectedFile,
          setSelectedFile,
          fetchData: fetchDataWithFollowups,
          path,
          filesWrap: true,
          taskManager: taskManager,
          uploadFolder,
          setUploadFolder,
          activeTab,
          // Prefer calling this to properly reset state when switching sections
          switchSection: onChangeSection,
          // Fallback for legacy callers
          setActiveTab: onChangeSection
        };
      };
      // Immediately publish the latest props so header icons can work without
      // having to call addFileHandler explicitly
      window.addFileHandler();
      // Also emit the current active tab for initial highlight
      try {
        window.dispatchEvent(
          new CustomEvent("filesTabChanged", { detail: activeTab })
        );
      } catch (_) {
        void 0;
      }

      // Cleanup on unmount
      return () => {
        window.addFileHandler = null;
        window.filesWrapperProps = null;
      };
    }, [
      setFilesList,
      setModal,
      setUploadedFiles,
      setAddFile,
      selectedFile,
      setSelectedFile,
      fetchDataWithFollowups,
      path,
      uploadFolder,
      setUploadFolder,
      activeTab,
      setActiveTab
    ]);

    const filteredFiles = filesData.filter((file) =>
      file.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    const [selectedFolder, setSelectedFolder] = useState("");

    return (
      <div
        className="fileWrapper"
        style={{
          backgroundColor:
            theme == "light" ? "#F8F2FD" : "var(--background-bg-dark)"
        }}
      >
        {true && (
          <div className="fileWrapperContainer">
            {isMobile && count > 0 ? (
              <div className="actionsIconMobileBox">
                <div className="top">
                  <div className="count">{count} Items Selected</div>
                  <div
                    className="actionsIconBoxWrapper"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px"
                    }}
                  >
                    {(() => {
                      const isTrash = activeTab + 1 === 3;
                      const isSharedWithMe = activeTab + 1 === 2;

                      // Action permission mapping
                      const PERMISSIONS = {
                        moveTo: 3,
                        copy: 2,
                        favorite: 37,
                        download: 6,
                        share: 5,
                        restore: 14,
                        delete: 15
                      };

                      return actionIconTitles.map((title, index) => {
                        const showIcon = isTrash
                          ? index === 5 || index === 6
                          : isSharedWithMe
                            ? index === 1
                            : index <= 1 || index === 6;

                        if (showIcon) {
                          const opId =
                            title === "delete"
                              ? isTrash
                                ? 15
                                : 4
                              : PERMISSIONS[title];
                          if (opId && isOrganisationUser && backendOperations) {
                            const email = sessionStorage.getItem("mail");
                            const allOwned = Object.keys(checkedRows).every(
                              (name) => {
                                // Find owner from namesArrays and ownerArrays
                                const idx = namesArrays.indexOf(name);
                                if (idx === -1) return false;
                                const owner = ownerArrays[idx];
                                return (
                                  owner === "you" || (email && owner === email)
                                );
                              }
                            );

                            if (
                              !allOwned &&
                              !backendOperations.includes(opId)
                            ) {
                              return null;
                            }
                          }

                          return (
                            <div
                              className="iconBox"
                              key={index}
                              onClick={() => setSelectedModal(title)}
                              style={{ cursor: "pointer" }}
                            >
                              <GetActionIcon
                                type={title}
                                color="var(--text-grey-strong)"
                              />
                            </div>
                          );
                        }
                        return null;
                      });
                    })()}
                  </div>
                  <div
                    className="right"
                    onClick={() => {
                      setCheckedRows({});
                    }}
                  >
                    <GetActionIcon
                      type="cross"
                      color="var(--text-grey-strong)"
                    />
                  </div>
                </div>
                {/* Modals rendered in TableTest.jsx with proper action handlers */}
              </div>
            ) : (
              <>
                {/* Header and filter bar moved to main header for minimalistic UI - no longer needed */}
              </>
            )}
            <div className="fileWrapperContainerTableBox">
              {/* <Table
            layout={layout}
            count={count}
            setCount={setCount}
            checkedRows={checkedRows}
            setCheckedRows={setCheckedRows}
            filesData={searchQuery ? filteredFiles : dataReceived}
            searchQuery={searchQuery}
            filteredFilesData={filteredFilesData}
            // uploadedFiles={uploadedFiles}
            setFilesData={setFilesData}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            setActiveTab={setActiveTab}
            activeTab={activeTab}
            menu={menu}
            setMenu={setMenu}
            selectedModal={selectedModal}
            setSelectedModal={setSelectedModal}
            setCurrentPath={setCurrentPath}
          /> */}

              <TableTest
                setTaskMonitorVisible={setTaskMonitorVisible}
                fetchData={fetchDataWithFollowups}
                showSharedTab={showSharedTab}
                layout={layout}
                folder={folder}
                count={count}
                setCount={setCount}
                checkedRows={checkedRows}
                setCheckedRows={setCheckedRows}
                filesData={searchQuery ? filteredFiles : filesData}
                searchQuery={searchQuery}
                selected={sortSelected}
                // filteredFilesData={Object.keys(checkedRows).length}
                filteredFilesData={filteredFilesData}
                // uploadedFiles={uploadedFiles}
                setFilesData={setFilesData}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
                setActiveTab={onChangeSection}
                activeTab={activeTab}
                menu={menu}
                setMenu={setMenu}
                selectedModal={selectedModal}
                setSelectedModal={setSelectedModal}
                setCurrentPath={setCurrentPath}
                currentPath={currentPath}
                setSelectedFolder={setSelectedFolder}
                selectedFolder={selectedFolder}
                setSelectedFile={setSelectedFile}
                selectedFile={selectedFile}
                setModal={setModal}
                setFilesList={setFilesList}
                modal={modal}
                taskManager={taskManager}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
                listedFolders={listedFolders}
                getReanderingList={getReanderingList}
                backendOperations={backendOperations}
                isOrganisationUser={isOrganisationUser}
                hasSpacePermission={hasSpacePermission}
              />
            </div>

            {modal &&
              filesList.length > 0 &&
              (isMobile ? (
                <Drawer
                  leftButtonWith="50%"
                  rightButtonWith="50%"
                  submitBtnText="Upload"
                  isVisible={modal}
                  showHeader={false}
                  handleSave={checkTheExistenceOfFile}
                  handleCancel={() => {
                    setFilesList([]);
                    // setSelectedFile(null);
                    setModal(false);
                  }}
                >
                  <UploadFileContent
                    files={filesList}
                    setFilesList={setFilesList}
                    setSelectedFile={setSelectedFile}
                    setIsDropDownVisible={setAddFile}
                    progress={progress}
                    timeRemaining={timeRemaining}
                  />
                </Drawer>
              ) : (
                <Modal
                  showHeader={false}
                  handleSave={checkTheExistenceOfFile}
                  handleCancel={() => {
                    setFilesList([]);
                    // setSelectedFile(null);
                    setModal(false);
                  }}
                >
                  <UploadFileContent
                    files={filesList}
                    setFilesList={setFilesList}
                    setSelectedFile={setSelectedFile}
                    setIsDropDownVisible={setAddFile}
                    progress={progress}
                    timeRemaining={timeRemaining}
                  />
                </Modal>
              ))}

            {uploadModal &&
              (isMobile ? (
                <Drawer
                  leftButtonWith="50%"
                  rightButtonWith="50%"
                  isVisible={uploadModal}
                  showHeader={false}
                  showFooter={false}
                >
                  <UploadDropDown
                    cancelUploadModal={cancelUploadModal}
                    showLoadingProgress={showLoadingProgress}
                    filesList={filesList}
                    setUploadModal={setUploadModal}
                    setFilesList={setFilesList}
                    setUploadedFiles={setUploadedFiles}
                    setCancelUploadModal={setCancelUploadModal}
                    setShowLoadingProgress={setShowLoadingProgress}
                    progress={progress}
                    timeRemaining={timeRemaining}
                    selectedFile={selectedFile}
                    setSelectedFile={setSelectedFile}
                    currentPath={currentPath}
                  />
                </Drawer>
              ) : (
                <UploadDropDown
                  cancelUploadModal={cancelUploadModal}
                  setShowLoadingProgress={setShowLoadingProgress}
                  filesList={filesList}
                  setUploadModal={setUploadModal}
                  setFilesList={setFilesList}
                  setUploadedFiles={setUploadedFiles}
                  showLoadingProgress={showLoadingProgress}
                  setCancelUploadModal={setCancelUploadModal}
                  progress={progress}
                  timeRemaining={timeRemaining}
                  selectedFile={selectedFile}
                  setSelectedFile={setSelectedFile}
                  currentPath={currentPath}
                />
              ))}

            {/* Mobile Add button moved to homepage header */}

            {cancelUploadModal && (
              <Modal
                submitBtnText="Cancel"
                closeBtnTxt="Discard"
                showFooter={true}
                // customClass="modalFooter"
                // width="70%"
                handleCancel={() => {
                  setUploadModal(true);
                  setCancelUploadModal(false);
                }}
                handleSave={() => setCancelUploadModal(false)}
              >
                <div className="modalContent">
                  <p className="title">
                    Are you sure you want to cancel all uploads?
                  </p>
                  <p className="description">
                    Uploads still in progress. Do you want to cancel them all?
                  </p>
                </div>
              </Modal>
            )}

            {/* Removed CircleLoading block to keep progress exclusively within the Operation Panel */}
          </div>
        )}
      </div>
    );
  }
);
export default memo(FilesWrapper);
